.filter {
  position: relative;
  cursor: pointer;
  display: flex;
  width: 100%;
  padding: var(--space-m);
  border-radius: var(--border-radius-xs);
  align-items: center;
  transition: background-color 0.15s ease-in-out;
}

.button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateX(10px);
  right: var(--space-xs);
  opacity: 0;
  transition: transform 0.15s ease-in-out, opacity 0.15s ease-in-out;
}

.type {
  text-transform: uppercase;
  font-weight: var(--font-weight-bold);
  margin-right: var(--space-xs);
  font-size: var(--font-size-s);
}

.filter:hover {
  background: rgb(176, 196, 205, 35%);

  .button {
    transform: translateY(-50%);
    opacity: 1;
  }
}
